// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verification-page {
  padding: 2rem 0;
}

.verification-hero {
  text-align: center;
  margin-bottom: 3rem;
  padding: 3rem 1rem;
  border-radius: 16px;
}

.verification-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.verification-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

.verification-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.verification-card {
  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 255, 157, 0.1);
}

.card-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: white;
}

.verification-card h2 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
}

.card-title {
  color: #ffffffc4 !important;
}
.card-description {
  color: #fff;
  margin-bottom: 2rem;
}

.verification-form {
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.serial-input {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
  transition: border-color 0.3s ease;
}

.serial-input:focus {
  outline: none;
  border-color: #00ff9d;
}

.serial-input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  gap: 1rem;
}

.btn-primary,
.btn-secondary {
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-primary {
  flex: 1;
  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 255, 157, 0.3);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-secondary {
  background: white;
  color: #333;
  border: 2px solid #e0e0e0;
}

.btn-secondary:hover {
  background: #f5f5f5;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.verification-result {
  padding: 1.5rem;
  border-radius: 12px;
  display: flex;
  gap: 1rem;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.verification-result.success {
  background: rgba(0, 255, 157, 0.1);
  border: 2px solid #00ff9d;
}

.verification-result.error {
  background: rgba(255, 71, 87, 0.1);
  border: 2px solid #ff4757;
}

.verification-result.warning {
  background: rgba(255, 168, 0, 0.1);
  border: 2px solid #ffa800;
}

.result-icon {
  flex-shrink: 0;
}

.result-icon svg {
  display: block;
}

.verification-result.success .result-icon {
  color: #00ff9d;
}

.verification-result.error .result-icon {
  color: #ff4757;
}

.verification-result.warning .result-icon {
  color: #ffa800;
}

.result-content h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
}

.result-content p {
  margin: 0 0 1rem 0;
  color: #666;
}

.product-info {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.info-grid {
  display: grid;
  gap: 1rem;
}

.info-item {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #666;
}

.info-value {
  color: #1a1a1a;
}

.verification-info {
  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.verification-info h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #1a1a1a;
}

.info-steps {
  margin-bottom: 2rem;
}

.step {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.step-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  flex-shrink: 0;
}

.step-content h4 {
  margin: 0 0 0.5rem 0;
  color: #1a1a1a;
}

.step-content p {
  margin: 0;
  color: #666;
  line-height: 1.6;
}

.help-section {
  padding: 1.5rem;
  background: rgba(0, 255, 157, 0.05);
  border-radius: 8px;
  border-left: 4px solid #00ff9d;
}

.help-section h4 {
  margin: 0 0 0.5rem 0;
  color: #1a1a1a;
}

.help-section p {
  margin: 0;
  color: #666;
}

.text-link {
  color: #00a3ff;
  text-decoration: none;
  font-weight: 600;
}

.text-link:hover {
  text-decoration: underline;
}

@media (max-width: 968px) {
  .verification-content {
    grid-template-columns: 1fr;
  }

  .verification-title {
    font-size: 2rem;
  }

  .info-item {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/verification/Verification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".verification-page {\n  padding: 2rem 0;\n}\n\n.verification-hero {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 3rem 1rem;\n  border-radius: 16px;\n}\n\n.verification-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(180deg, #ffffff 0%, #00a3ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.verification-subtitle {\n  font-size: 1.2rem;\n  color: #666;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.verification-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.verification-card {\n  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 255, 157, 0.1);\n}\n\n.card-icon {\n  width: 64px;\n  height: 64px;\n  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  color: white;\n}\n\n.verification-card h2 {\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n  color: #1a1a1a;\n}\n\n.card-title {\n  color: #ffffffc4 !important;\n}\n.card-description {\n  color: #fff;\n  margin-bottom: 2rem;\n}\n\n.verification-form {\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.serial-input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: \"Courier New\", monospace;\n  letter-spacing: 1px;\n  transition: border-color 0.3s ease;\n}\n\n.serial-input:focus {\n  outline: none;\n  border-color: #00ff9d;\n}\n\n.serial-input:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.btn-primary {\n  flex: 1;\n  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 255, 157, 0.3);\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: white;\n  color: #333;\n  border: 2px solid #e0e0e0;\n}\n\n.btn-secondary:hover {\n  background: #f5f5f5;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.verification-result {\n  padding: 1.5rem;\n  border-radius: 12px;\n  display: flex;\n  gap: 1rem;\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.verification-result.success {\n  background: rgba(0, 255, 157, 0.1);\n  border: 2px solid #00ff9d;\n}\n\n.verification-result.error {\n  background: rgba(255, 71, 87, 0.1);\n  border: 2px solid #ff4757;\n}\n\n.verification-result.warning {\n  background: rgba(255, 168, 0, 0.1);\n  border: 2px solid #ffa800;\n}\n\n.result-icon {\n  flex-shrink: 0;\n}\n\n.result-icon svg {\n  display: block;\n}\n\n.verification-result.success .result-icon {\n  color: #00ff9d;\n}\n\n.verification-result.error .result-icon {\n  color: #ff4757;\n}\n\n.verification-result.warning .result-icon {\n  color: #ffa800;\n}\n\n.result-content h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.2rem;\n}\n\n.result-content p {\n  margin: 0 0 1rem 0;\n  color: #666;\n}\n\n.product-info {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.info-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.info-item {\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  gap: 1rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #666;\n}\n\n.info-value {\n  color: #1a1a1a;\n}\n\n.verification-info {\n  background: linear-gradient(135deg, #0f3460 0%, #1a1a2e 100%);\n  border-radius: 16px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.verification-info h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #1a1a1a;\n}\n\n.info-steps {\n  margin-bottom: 2rem;\n}\n\n.step {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.step-number {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #edf3ee 0%, #00a3ff 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.step-content h4 {\n  margin: 0 0 0.5rem 0;\n  color: #1a1a1a;\n}\n\n.step-content p {\n  margin: 0;\n  color: #666;\n  line-height: 1.6;\n}\n\n.help-section {\n  padding: 1.5rem;\n  background: rgba(0, 255, 157, 0.05);\n  border-radius: 8px;\n  border-left: 4px solid #00ff9d;\n}\n\n.help-section h4 {\n  margin: 0 0 0.5rem 0;\n  color: #1a1a1a;\n}\n\n.help-section p {\n  margin: 0;\n  color: #666;\n}\n\n.text-link {\n  color: #00a3ff;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.text-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 968px) {\n  .verification-content {\n    grid-template-columns: 1fr;\n  }\n\n  .verification-title {\n    font-size: 2rem;\n  }\n\n  .info-item {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
